import { useMemo } from 'react';
import { ALL_DUMMY_PLACES } from '../constants/popularPlaces';

function norm(s = '') {
  return String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
}

/**
 * Local city/airport filter — no network calls.
 */
export function usePlacesAutocomplete(term, { types = ['city', 'airport'], minLength = 2, limit = 10 } = {}) {
  const trimmed = (term || '').trim();

  const results = useMemo(() => {
    if (trimmed.length < minLength) return [];

    const q = norm(trimmed);
    const allowed = new Set(types);

    return ALL_DUMMY_PLACES.filter((place) => {
      if (!allowed.has(place.type)) return false;
      const hay = norm(
        [place.name, place.city_name, place.code, place.country_name].filter(Boolean).join(' ')
      );
      return hay.includes(q);
    }).slice(0, limit);
  }, [trimmed, types, minLength, limit]);

  return {
    results,
    loading: false,
    error: null,
  };
}
